import { FC } from "react";
import { useParams } from "react-router-dom";

import { useCrudNavigate } from "@ryde/redux";
import { DrawerType, EditFormMode } from "@ryde/shared";

import { JourneyEditFormDrawer } from "../../drawers";

interface IJourneyEdit {
  isAddRoute?: boolean;
}

export const JourneyEdit: FC<IJourneyEdit> = ({ isAddRoute }) => {
  const { id } = useParams<{ id: string }>();
  const { navigateToList } = useCrudNavigate("journey");
  const idOpen = Number(id) && !isAddRoute ? Number(id) : undefined;
  const idCopyFrom = Number(id) && isAddRoute ? Number(id) : undefined;
  return (
    <JourneyEditFormDrawer
      type={DrawerType.JourneyEditForm}
      mode={EditFormMode.CrudRoute}
      onCloseDrawer={navigateToList}
      id={idOpen}
      idCopyFrom={idCopyFrom}
    />
  );
};
